export const FORGETME_FOREVENT_START = 'FORGETME_FOREVENT_START';
export const FORGETME_FOREVENT_SUCCESS = 'FORGETME_FOREVENT_SUCCESS';
export const FORGETME_FOREVENT_FAILURE = 'FORGETME_FOREVENT_FAILURE';